export function requestLogin(body = {}) {
    return {
        type: "LOGIN_RESQUEST",
        body
    };
}


// WEBPACK FOOTER //
// ./src/store/actions/login.js